import { useField } from 'formik';

import { Card } from 'components/Card';
import { CheckboxWithLabel } from 'components/checkbox/CheckboxWithLabel';
import { useTranslation } from 'src/contexts/translation-context';
import { OrderDocumentType } from 'src/types/enums';
import { OrderDocumentTypeToTranslationKey } from '../../../order/utils/document-validation';

const REQUIRED_DOCUMENT_TYPES = [
  OrderDocumentType.Cmr,
  OrderDocumentType.DeliveryNote,
  OrderDocumentType.WeighSlip,
  OrderDocumentType.PalletNote,
  OrderDocumentType.AnnexII,
  OrderDocumentType.T1Document,
  OrderDocumentType.AnnexVII,
];

/** The `requiredDocuments` field, shared by the create and edit customer forms. */
export const RequiredDocumentsCard: React.FC = () => {
  const { i18n } = useTranslation();
  const [field, , helpers] = useField<OrderDocumentType[]>({ name: 'requiredDocuments' });

  // CMR is required whatever the customer config says (see document-validation.server.ts).
  const isRequired = (type: OrderDocumentType) => type === OrderDocumentType.Cmr || field.value.includes(type);

  return (
    <Card title="Vereiste documenten">
      <p className="text-sm text-fg-muted mb-2">
        Welke documenten moet de vervoerder aanleveren voordat een dossier groen mag worden voor self-billing? Dezelfde
        set wordt als gemergede CMR-bundel naar de klant verstuurd.
      </p>
      <div className="grid grid-cols-2 gap-x-2">
        {REQUIRED_DOCUMENT_TYPES.map((type) => (
          <CheckboxWithLabel
            key={type}
            labelText={i18n(OrderDocumentTypeToTranslationKey[type])}
            isChecked={isRequired(type)}
            isDisabled={type === OrderDocumentType.Cmr}
            onChange={(isChecked) => {
              helpers.setValue(
                REQUIRED_DOCUMENT_TYPES.filter((other) => (other === type ? isChecked : isRequired(other))),
              );
            }}
          />
        ))}
      </div>
    </Card>
  );
};
